// extracted by mini-css-extract-plugin
export default {"img_button":"img_button___i7p0r","img":"img___gzXsv","hover_img":"hover_img___DcBRt","disabled":"disabled___DlijI"};